import { Project } from "projen/lib";
import { AgentRuleBundle } from "../agent-config-options";
import { AGENT_RULE_SCOPE } from "../types";
import { findProjectsWithDep, hasDep } from "./utils";

/**
 * Jest bundle — auto-detected when Jest is in dependencies.
 */
export const jestBundle: AgentRuleBundle = {
  name: "jest",
  description: "Jest testing conventions and patterns",
  appliesWhen: (project: Project) => hasDep(project, "jest"),
  findApplicableProjects: (project: Project) =>
    findProjectsWithDep(project, "jest"),
  rules: [
    {
      name: "jest-testing",
      description: "Jest testing conventions and patterns",
      scope: AGENT_RULE_SCOPE.FILE_PATTERN,
      filePatterns: ["**/*.test.ts", "**/*.spec.ts"],
      content: [
        "# Jest Testing Patterns",
        "",
        "## Mandatory Requirements",
        "",
        "- **Tests MUST be created or updated whenever code functionality is added or changed**",
        "- This applies to all code changes, including:",
        "  - New features and functionality",
        "  - Bug fixes",
        "  - Refactoring that changes behavior",
        "  - API changes",
        "  - Configuration changes that affect functionality",
        "- Tests should be written or updated as part of the same change that modifies the code",
        "",
        "## Test Structure",
        "",
        "- Use **Jest** with SWC for fast compilation",
        "- Test files: `.spec.ts` or `.test.ts` (co-located with source)",
        "- Use descriptive test names: `describe('ClassName', () => { it('should do something specific', () => {}) })`",
        "- Prefer snapshot tests for complex object structures",
        "- Mock external dependencies appropriately",
        "",
        "## Test Organization",
        "",
        "- Co-locate test files with source files",
        "- Test files can use dev dependencies (ESLint rule override)",
        "- Use `@swc/jest` for fast compilation",
        "- Configure Jest in `jest.config.json` (not in package.json)",
        "",
        "## Example Test Structure",
        "",
        "```typescript",
        "import { MyClass } from './my-class';",
        "",
        "describe('MyClass', () => {",
        "  it('should do something specific', () => {",
        "    // Test implementation",
        "  });",
        "});",
        "```",
      ].join("\n"),
      tags: ["testing"],
    },
  ],
  claudePermissions: {
    allow: ["Bash(npx jest:*)"],
  },
};
